import {Plus} from 'lucide-react';
import * as React from 'react';
import {cn} from 'src/lib/utils';

type Props = Omit<React.ComponentProps<'button'>, 'type'> & {
  children: React.ReactNode;
};

export const DashedAddButton = ({children, className, ...props}: Props) => {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        'text-muted-foreground hover:text-foreground hover:border-foreground/30 hover:bg-muted/50 flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-lg border-2 border-dashed py-3 text-sm transition-colors',
        className,
      )}
    >
      <Plus className="h-4 w-4" />
      {children}
    </button>
  );
};
